function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';

/**
 * Check wheter an item is clickable
 *
 * Used to set an index on clickable items only.
 * Non-clicable items should never be highlighted.
 */
var isClickableDropdownItem = function isClickableDropdownItem(child) {
  return /*#__PURE__*/React.isValidElement(child) && child.type.toString().includes('telia-dropdown-item') && !child.props.header && !child.props.divider && child.props.onClick;
};
/**
 * In order to set programatically set the indices on the dropdown items,
 * we need to recursivly find and clone all items.
 *
 * This enables using custom components to render DropdownItems in a Dropdown.
 * Eg. when you want a scroll continer for a large list of items.
 *
 * Providing flat = true disregards wrappers,
 * and only returns the actula dropdown items
 * ie. retuns a flat list of items
 */


function getItemsRecursive(children, index, flat) {
  return React.Children.map(children, function (child) {
    /**
     * Clickable dropdown items receive an indexed
     * used to keep track active item
     */
    if ( /*#__PURE__*/React.isValidElement(child) && isClickableDropdownItem(child)) {
      index += 1;
      return /*#__PURE__*/React.cloneElement(child, {
        index: index
      });
    } else if ( /*#__PURE__*/React.isValidElement(child) && child.props.children) {
      /**
       * Disregard the wrapper and return only the children
       */
      if (flat) {
        return getItemsRecursive(child.props.children, index);
      } else {
        /**
         * return the wrapper and children
         */
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          children: getItemsRecursive(child.props.children, index)
        }));
      }
    }

    return child;
  });
}
/**
 * Get all dropdown items with appropriate index
 * for navigations with keyboard and highlighting.
 *
 * By defualt returns the children in the structure which they occur.
 * Returns a flat list of only DropdownItems if flat = true
 */


function getIndexedDropdownItems(children, flat) {
  return React.Children.map(children, function (child) {
    /**
     * If the child is a DropdownMenu we set indecies on all child dropdown items.
     */
    if ( /*#__PURE__*/React.isValidElement(child) && child.type.toString().includes('telia-dropdown-content')) {
      return getItemsRecursive(child.props.children, -1, flat);
    } else {
      /**
       * Any other children of the Dropdown will be disregarded in the process of setting indecies.
       * They will be rendered as provided.
       */
      return null;
    }
  });
}
/**
 * The highest highlight index for a collection of children within a dropdown
 */


var getMaxHighlightIndex = function getMaxHighlightIndex(children) {
  /**
   * Retrieve a flat list of all clickable dropdown items
   */
  var flatList = getIndexedDropdownItems(children, true);
  var clickableItems = flatList ? flatList.filter(isClickableDropdownItem) : [];
  return clickableItems.length - 1;
};

export { getIndexedDropdownItems, getMaxHighlightIndex };